module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-265.b1d4bde9.svg";